import React, { useEffect, useState } from "react"
import { timeLineTemplate } from "../../../../../../stateManager/store/table/actions";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../../../../stateManager/store";
import { updateElement } from "../../../../../../stateManager/store/formCreation_v2/actions";
import { templateSvgs } from "./templateSvg";

export const TimeLineTemplateImg = (dType: any) => {

    const [selectedTemplate, setSelectedTemplate] = useState<any>({
        "_id": "template1",
        "icon": "/static/media/template1.fa337289.svg",
        "label": "Template 1",
        "style": {
           
        }
    })
    const { selectedElementId, components, deviceType } = useSelector((state: AppState) => state.formJson);
    const selectedTemplateIcon = components[selectedElementId]?.properties?.styles[deviceType]?.template?.icon
    const { styles = {} } = components[selectedElementId]?.properties || {}
    const [timelineDefault, setTimelineDefault] = useState<any>(null)
    const dispatch = useDispatch();
    const [newTempate, setNewTemplate] = useState([])
    const mobileDeviceTimeline = ["template1", "template2", "template3", "template4", "template5", "template6"]
    const mobileHorizontalTimeline = ["template7", "template8", "template9", "template10", "template11", "template12"]

    const webTabTemplate = ["template13", "template14", "template15", "template16", "template17", "template18", "template7", "template8", "template9", "template10", "template11", "template12" ]
    const mobileTemplate = ["template1", "template2", "template3", "template4", "template5", "template6", "template7", "template8", "template9", "template10", "template11", "template12"]
    useEffect(() => {
        if (selectedTemplate) {
            dispatch(timeLineTemplate(selectedTemplate))
        }
    }, [selectedTemplate])

    useEffect(() => {
        if(deviceType === "Sm"){
            const val: any = templateSvgs.map((el: any) => {
                if(mobileDeviceTimeline.includes(el._id) || mobileHorizontalTimeline.includes(el._id)){
                    return el
                }
            }).filter((e: any) => {return e})
            setNewTemplate(val)
        }else{
            const val: any = templateSvgs.map((el: any) => {
                if (!mobileDeviceTimeline.includes(el._id)) {
                    return el
                }
            }).filter((e: any) => { return e })
            setNewTemplate(val)
        }
    },[deviceType])

    const handleChange = (path: string, value: any) => {
        const deviceMappings: Record<string, string[]> = {
            Lg: ["Md"],
            Md: ["Lg"],
            Sm: ["Md", "Lg"],
        };
        deviceMappings[deviceType]?.forEach(mappedPath => {
            if (!styles[mappedPath]?.template && deviceType != 'Sm') {
                const findIndex = webTabTemplate.indexOf(value._id.trim());
                dispatch(updateElement({ id: selectedElementId, path: `properties.styles.${mappedPath}.template`, value }));
                if(!styles["Sm"]?.template && findIndex >= 0) {
                    const val: any = templateSvgs.map((el: any) => {
                        if(el._id===mobileTemplate[findIndex]){
                            return el
                        }
                    }).filter((e: any) => {return e})
                    let smValue: any = val.length> 0 ? val[0] : {}
                    dispatch(updateElement({ id: selectedElementId, path: `properties.styles.Sm.template`, value: smValue }));
                }
            }
            
            if (!styles[mappedPath]?.template && deviceType == 'Sm') {
                const findIndex = mobileTemplate.indexOf(value._id.trim());
                dispatch(updateElement({ id: selectedElementId, path: `properties.styles.${mappedPath}.template`, value }));
                if(findIndex >= 0) {
                    const val: any = templateSvgs.map((el: any) => {
                        if(el._id===webTabTemplate[findIndex]){
                            return el
                        }
                    }).filter((e: any) => {return e})
                    let mdValue: any = val.length> 0 ? val[0] : {}
                    dispatch(updateElement({ id: selectedElementId, path: `properties.styles.Md.template`, value: mdValue }));
                    dispatch(updateElement({ id: selectedElementId, path: `properties.styles.Lg.template`, value: mdValue }));
                } 
            }
        });
        dispatch(updateElement({ id: selectedElementId, path: "properties.template" , value }));
        dispatch(updateElement({ id: selectedElementId, path, value }));
    };

    useEffect(() => {
        if (styles[deviceType]?.template) {
            setTimelineDefault(styles[deviceType])
        }
    }, [styles[deviceType]?.template])

    useEffect(() => {
        if (timelineDefault) {
            handleChange(`properties.styles.${deviceType}.template` ,timelineDefault?.template);
        }
    }, [timelineDefault])

    const handleSelectedTemplate = (item: any) => {
        setTimelineDefault((prev: any) => ({
            ...prev,
            "template": item,
        }))
        setSelectedTemplate(item)
    }

    return (
        <div style={{ width: "100%", height: "100%", margin: "3px", display: "flex", overflow: "auto", flexWrap: "wrap", gap: "15px" }}>
            {
                newTempate.map((item: any, i) => {
                    return <div onClick={() => { handleSelectedTemplate(item) }}
                        style={{
                            cursor: "pointer", margin: "5px", display: "flex", height: 100,
                            border: ((item && item?.icon) === (selectedTemplateIcon)) ? "1px solid #0466C8" : "1px solid #D9D9D9",
                            borderRadius: "3px"
                        }}>
                        <img src={item.icon} style={{ margin: "5px" }} height="30px" width="60px" alt="templates" />
                    </div>
                })
            }
        </div>
    )
};
